var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables47 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "732.9px",
    height: "773.809px",
    viewBox: "0 0 732.9 773.809",
    enableBackground: "new 0 0 732.9 773.809",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.313,264.775C604.247,370.507,539,641.063,435.37,719.467 c-129.727,98.175-341.529,58.691-416.893-81.094C-19.51,567.909,5.762,497.594,51.852,440.314 c76.13-94.651,313.092-208.165,443.524-322.308c-21.065-7.709-43.653-18.653-70.423-31.732 c85.092-115.438,163.002-97.973,200.224-46.196l68.194-33.166l35.961,33.343l-34.46,80.097 c48.629,35.44,64.714,108.779-38.282,197.974C644.898,298.487,634.685,281.063,626.313,264.775L626.313,264.775z M212.038,378.779 c-48.41,30.896-94.812,76.932-117.608,125.572l53.394,40.168c38.055-31.804,86.755-57.525,121.153-76.409L212.038,378.779 L212.038,378.779z M125.187,565.649l-41.584-31.271c-6.889,27.656-4.892,55.367,9.869,80.771 C99.361,597.499,110.72,581.007,125.187,565.649z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables47, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-47.eaac4b73.svg";
export { ForwardRef as ReactComponent };